exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".collection-banner h2{font-weight:200;margin-bottom:1rem;font-size:28px;font-size:1.75rem}@media (min-width:768px){.collection-banner h2{font-size:36px;font-size:2.25rem}}.collection-banner p{margin-bottom:0;font-size:14px;font-size:.875rem}@media (min-width:768px){.collection-banner p{font-size:18px;font-size:1.125rem}}", ""]);

